<div fxLayout="row" fxLayoutAlign="start center" mat-dialog-title>
  <h2 class="headline m-0" fxFlex="auto">{{dialog_title}}</h2>

  <button class="text-secondary" mat-dialog-close mat-icon-button type="button">
    <mat-icon [icIcon]="icClose"></mat-icon>
  </button>
</div>

<mat-divider class="-mx-6 text-border"></mat-divider>

<div *ngIf="!configurationLoader; else inventoryDetail">
  <div fxLayout="row" fxLayoutAlign="space-around center" class="mt-4">
    <mat-progress-spinner
      class="progbar"
      strokeWidth="4"
      diameter="60"
      mode="indeterminate"
      color="primary"
    >
    </mat-progress-spinner>
  </div>
</div>

<ng-template #inventoryDetail>
  <div fxLayout="column">
    <div class="overflow-auto" fxLayout="column">
      <div fxLayout="row" fxLayoutAlign="start center">
        <mat-tab-group
          class="border-0 grid profile-tabs clean-tabs mat-elevation-z4"
          fxFlex="auto"
          (selectedIndexChange)="onSelectTab($event)"
          #tabGroup
        >
          <mat-tab label="Full Config Diff">
            <div fxLayout="column" [ngStyle]="{ height: getHeight(230) }">
              <div class="pt-4" fxLayout="row" *ngIf="!loadEditor;">
                <div fxFlex="50">
                  <div fxLayout="column">
                    <mat-card-subtitle>
                      <b>Device Current Config</b>
                    </mat-card-subtitle>
                  </div>
                </div>
                <div fxFlex="50">
                  <div fxLayout="column">
                    <mat-card-subtitle>
                      <b>Device Configuration After Changes Applied</b>
                    </mat-card-subtitle>
                  </div>
                </div>
              </div>
              <div fxLayout="column" style="height: 100%">
                <div fxLayout="row" class="mb-4">
                  <mat-slide-toggle fxLayoutAlign="start start" fxFlex color="primary" (change)="onToggleChange($event)">
                    <span class="">Separate Scroll</span>
                  </mat-slide-toggle>
                </div>
                <div class="overflow-y-auto" fxFlex="auto">
                  <ng-container *ngIf="hasCompareData(compareData); else noOption1Data">
                    <ng-container *ngIf="isEditorShowSeprate; else diffOption1">
                    <div fxLayout="row" fxFlex="100">
                      <div fxFlex="50">
                        <ngx-monaco-editor style="height: 100%" 
                          [options]="editorOptions"
                          [(ngModel)]="compareData.SourceCode"
                          (init)="editorInit($event)"
                        >
                        </ngx-monaco-editor>
                      </div>
                      <div fxFlex="50">
                        <ngx-monaco-editor style="height: 100%" 
                          [options]="editorOptions"
                          [(ngModel)]="compareData.TargetCode"
                          (init)="editorInit($event)"
                        >
                        </ngx-monaco-editor>
                      </div>
                    </div>
                    </ng-container>
                  </ng-container>
                  <ng-template #diffOption1>
                    <ngx-monaco-diff-editor fxFlex
                      [options]="editorOptions" 
                      [original]="compareData.SourceCode" 
                      [modified]="compareData.TargetCode" 
                      (init)="editorInit($event)"
                      style="height: 100%" 
                    ></ngx-monaco-diff-editor>
                  </ng-template>
                  <ng-template #noOption1Data>
                    <div class="empty-code-state">No generated code available for this comparison.</div>
                  </ng-template>
                </div>
              </div>
              <div fxLayout="row" class="mt-4" fxFlex *ngIf="loadEditor;">
                <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex>
                  <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Resource Type Diff">
            <div fxLayout="column" class="w-full" [ngStyle]="{ height: getHeight(230) }">
              <div *ngIf="!configurationLoaderV2; else opt2">
                <div fxLayout="row" fxLayoutAlign="space-around center" class="mt-4">
                  <mat-progress-spinner
                    class="progbar"
                    strokeWidth="4"
                    diameter="60"
                    mode="indeterminate"
                    color="primary"
                  >
                  </mat-progress-spinner>
                </div>
              </div>
              <ng-template #opt2>
                <div class="pt-4" fxLayout="row" *ngIf="!loadEditor;">
                  <div fxFlex="50">
                    <div fxLayout="column">
                      <mat-card-subtitle>
                        <b>Device Current Config (filtered by Resource Type from Changes)</b>
                      </mat-card-subtitle>
                    </div>
                  </div>
                  <div fxFlex="50">
                    <div fxLayout="column">
                      <mat-card-subtitle>
                        <b>Changes to be Pushed</b>
                      </mat-card-subtitle>
                    </div>
                  </div>
                </div>
                <div fxLayout="column" style="height: 100%">
                  <div fxLayout="row" class="mb-4">
                    <mat-slide-toggle fxLayoutAlign="start start" fxFlex color="primary" (change)="onToggleChangeOption2($event)">
                      <span class="">Separate Scroll</span>
                    </mat-slide-toggle>
                  </div>
                  <div class="overflow-y-auto" fxFlex="auto">
                    <ng-container *ngIf="hasCompareData(compareDataV2); else noOption2Data">
                      <ng-container *ngIf="isEditorShowSeprateOption2; else diffOption2">
                      <div fxLayout="row" fxFlex="100">
                        <div fxFlex="50">
                          <ngx-monaco-editor style="height: 100%" 
                            [options]="editorOptions"
                            [(ngModel)]="compareDataV2.SourceCode"
                            (init)="editorInit($event)"
                          >
                          </ngx-monaco-editor>
                        </div>
                        <div fxFlex="50">
                          <ngx-monaco-editor style="height: 100%" 
                            [options]="editorOptions"
                            [(ngModel)]="compareDataV2.TargetCode"
                            (init)="editorInit($event)"
                          >
                          </ngx-monaco-editor>
                        </div>
                      </div>
                      </ng-container>
                    </ng-container>
                    <ng-template #diffOption2>
                      <ngx-monaco-diff-editor fxFlex
                        [options]="editorOptions" 
                        [original]="compareDataV2.SourceCode" 
                        [modified]="compareDataV2.TargetCode" 
                        (init)="editorInit($event)"
                        style="height: 100%" 
                      ></ngx-monaco-diff-editor>
                    </ng-template>
                    <ng-template #noOption2Data>
                      <div class="empty-code-state">No generated code available for the resource type diff.</div>
                    </ng-template>
                  </div>
                </div>
                <div fxLayout="row" class="mt-4" fxFlex *ngIf="loadEditor;">
                  <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex>
                    <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
                  </div>
                </div>
              </ng-template>
            </div>
          </mat-tab>
          <mat-tab label="Matched Changes Diff">
            <div fxLayout="column" class="w-full" [ngStyle]="{ height: getHeight(230) }">
              <div *ngIf="!configurationLoaderV3; else opt3">
                <div fxLayout="row" fxLayoutAlign="space-around center" class="mt-4">
                  <mat-progress-spinner
                    class="progbar"
                    strokeWidth="4"
                    diameter="60"
                    mode="indeterminate"
                    color="primary"
                  >
                  </mat-progress-spinner>
                </div>
              </div>
              <ng-template #opt3>
                <div class="pt-4" fxLayout="row" *ngIf="!loadEditor;">
                  <div fxFlex="50">
                    <div fxLayout="column">
                      <mat-card-subtitle>
                        <b>Device Current Config (filtered by match with changes applied)</b>
                      </mat-card-subtitle>
                    </div>
                  </div>
                  <div fxFlex="50">
                    <div fxLayout="column">
                      <mat-card-subtitle>
                        <b>Changes to be Pushed</b>
                      </mat-card-subtitle>
                    </div>
                  </div>
                </div>
                <div fxLayout="column" style="height: 100%">
                  <div fxLayout="row" class="mb-4">
                    <mat-slide-toggle fxLayoutAlign="start start" fxFlex color="primary" (change)="onToggleChangeOption3($event)">
                      <span class="">Separate Scroll</span>
                    </mat-slide-toggle>
                  </div>
                  <div class="overflow-y-auto" fxFlex="auto">
                    <ng-container *ngIf="hasCompareData(compareDataV3); else noOption3Data">
                      <ng-container *ngIf="isEditorShowSeprateOption3; else diffOption3">
                      <div fxLayout="row" fxFlex="100">
                        <div fxFlex="50">
                          <ngx-monaco-editor style="height: 100%" 
                            [options]="editorOptions"
                            [(ngModel)]="compareDataV3.SourceCode"
                            (init)="editorInit($event)"
                          >
                          </ngx-monaco-editor>
                        </div>
                        <div fxFlex="50">
                          <ngx-monaco-editor style="height: 100%" 
                            [options]="editorOptions"
                            [(ngModel)]="compareDataV3.TargetCode"
                            (init)="editorInit($event)"
                          >
                          </ngx-monaco-editor>
                        </div>
                      </div>
                      </ng-container>
                    </ng-container>
                    <ng-template #diffOption3>
                      <ngx-monaco-diff-editor fxFlex
                        [options]="editorOptions" 
                        [original]="compareDataV3.SourceCode" 
                        [modified]="compareDataV3.TargetCode" 
                        (init)="editorInit($event)"
                        style="height: 100%" 
                      ></ngx-monaco-diff-editor>
                    </ng-template>
                    <ng-template #noOption3Data>
                      <div class="empty-code-state">No generated code available for the matched changes diff.</div>
                    </ng-template>
                  </div>
                </div>
                <div fxLayout="row" class="mt-4" fxFlex *ngIf="loadEditor;">
                  <div fxLayout="row" fxLayoutAlign="space-around start" fxFlex>
                    <mat-progress-spinner strokeWidth="4" diameter="60" mode="indeterminate" color="primary"></mat-progress-spinner>
                  </div>
                </div>
              </ng-template>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
</ng-template>
